import BaseService from '@/services/BaseService'

class FabricanteService extends BaseService {
    constructor(){
        super('/v1/fabricantes')
    }
}

export default new FabricanteService